export default "__VITE_ASSET__DCNIjtYs__"